var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    staticClass: "solid-text-button",
    on: {
      "click": _vm.clickHandler
    }
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")]);

}
var staticRenderFns = []

export { render, staticRenderFns }